document.documentElement.classList.remove('no_js');

window.addEventListener('load', (event) => {
  // window.scrollTo(0,0);
  document.body.classList.add('page_loaded');
});
